module.exports = __webpack_public_path__ + "img/icon.ce67bfee.png";